import { useTranslations } from 'next-intl';
import { canShowAverageAdvancedGroupPrice } from 'src/helpers';
import { EnumOptionKind, EnumPriceUnit, Option } from 'src/types';

const DisplayBookingFormPriceUnit: React.FC<{
  option: Option;
  totalQty: number;
}> = ({ option, totalQty }) => {
  const translation = useTranslations('components.DisplayBookingFormPriceUnit');
  const text =
    option.kind === EnumOptionKind.flexibleAdventure
      ? `/${translation('day')}`
      : option.kind === EnumOptionKind.stay
      ? `/${translation('night')}`
      : canShowAverageAdvancedGroupPrice(option) && totalQty === 0
      ? `/${translation('person')}`
      : option.priceUnit === EnumPriceUnit.perGroup
      ? option.yachtTrip
        ? `/${translation('yacht')}`
        : `/${translation('group')}`
      : option.priceUnit === EnumPriceUnit.perRoom
      ? totalQty > 0
        ? ''
        : `/${translation('person')}`
      : `/${translation('person')}`;

  // Wrap in a span instead of returning a bare text node. Browser translators
  // (e.g. Chrome Translate) replace text nodes with <font> elements, which makes React
  // crash with "removeChild ... not a child of this node" when it later removes the text.
  return text ? <span>{text}</span> : null;
};

export default DisplayBookingFormPriceUnit;
